// src/services/idiomaArte.js
// Textos fijos de las imágenes para el cliente, en portugués y en español.
// Lo que escribe el admin (observaciones, Mi política, nombres) se muestra tal cual.

export const IDIOMAS = [
  { id: 'pt', label: 'Português' },
  { id: 'es', label: 'Español' },
];

const MESES = {
  pt: ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'],
  es: ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'],
};
const SEMANA = {
  pt: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
  es: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
};

const PAGOS = {
  pt: { PIX: 'PIX', Dinheiro: 'Dinheiro', Boleto: 'Boleto', 'Cartão de crédito': 'Cartão de crédito', Faturado: 'Faturado' },
  es: { PIX: 'PIX', Dinheiro: 'Efectivo', Boleto: 'Boleto', 'Cartão de crédito': 'Tarjeta de crédito', Faturado: 'Facturado' },
};

const CABINAS_ES = {
  econômica: 'económica', economica: 'económica', 'premium econômica': 'premium económica', 'premium economy': 'premium economy',
  executiva: 'ejecutiva', business: 'business', primeira: 'primera', 'primeira classe': 'primera clase',
};

const TX = {
  pt: {
    lema1: 'Mais que viagens,', lema2: 'realizamos sonhos!',
    pasajeros: 'PASSAGEIROS', proximoDestino: 'SEU PRÓXIMO DESTINO', soloIda: 'SÓ IDA', fechaOrc: 'DATA DO ORÇAMENTO', preparadoPara: 'PREPARADO PARA',
    vuelo: 'VOO', directo: 'Voo direto', una: '1 conexão', varias: (n) => `${n} conexões`, aerolinea: 'Companhia aérea',
    salida: 'SAÍDA', llegada: 'CHEGADA', valorTotal: 'VALOR TOTAL', validoHasta: 'Válido até', clase: 'Classe',
    formaPago: 'FORMA DE PAGAMENTO', formasPago: 'FORMAS DE PAGAMENTO', pagoPix: 'Pagamento via PIX',
    tarjetaHasta: (n) => `Cartão de crédito em até ${n}x`, hastaCuotas: (n) => `(até ${n}x)`,
    observaciones: 'OBSERVAÇÕES', wsp: 'Fale conosco no WhatsApp', soporte1: 'Suporte', soporte2: 'especializado', buenViaje: 'Boa viagem!',
    // itinerario
    itinDe: (n) => `ITINERÁRIO DE ${n}`, itin: 'SEU ITINERÁRIO DE VIAGEM', itinCorto: 'SEU ITINERÁRIO', saliendo: 'SAINDO DE BOA VISTA', tuViaje: 'SUA VIAGEM',
    llegadaBV: 'CHEGADA EM BOA VISTA', hospedaje: 'HOSPEDAGEM EM BOA VISTA', noche: 'noite', noches: 'noites',
    delAl: (a, b) => `de ${a} a ${b}`, busBVM: 'ÔNIBUS BOA VISTA → MANAUS', salidaA: (f, h) => `Saída ${f ? `${f} ` : ''}às ${h}`,
    llegaManaus: (f, h) => `Chegada em Manaus ${f} às ${h}`, llegaA: (f, h) => `Chegada ${f ? `${f} ` : ''}às ${h}`,
    vueloMA: (d) => `VOO MANAUS → ${d}`, busHasta: (c) => `ÔNIBUS ATÉ ${c}`, destinoFinal: 'O DESTINO FINAL', horarioPorConfirmar: 'Horário a confirmar',
    valorPaquete: 'VALOR DO PACOTE', incluye: 'O PACOTE INCLUI', paqueteCompleto: 'Pacote completo',
    inc1: 'Hospedagem em Boa Vista', inc2: 'Ônibus Boa Vista → Manaus', inc3: (d) => `Passagem aérea Manaus${d ? ` → ${d}` : ''}`,
    oReales: (v, t) => `ou R$ ${v}  (câmbio R$ ${t})`, oRealesCorto: (v) => `ou R$ ${v}`,
    // hotel / servicios / total
    hotel: 'HOTEL', servicio: 'SERVIÇO', bus: 'ÔNIBUS', checkIn: 'ENTRADA', checkOut: 'SAÍDA', huespedes: (n) => `${n} ${n === 1 ? 'hóspede' : 'hóspedes'}`,
    habitaciones: (n) => `${n} ${n === 1 ? 'quarto' : 'quartos'}`, detalle: 'DETALHE', total: 'TOTAL', pacoteFechado: 'Pacote fechado',
    resumen: 'RESUMO DO ORÇAMENTO', incluyeLista: 'O ORÇAMENTO INCLUI',
  },
  es: {
    lema1: 'Más que viajes,', lema2: '¡realizamos sueños!',
    pasajeros: 'PASAJEROS', proximoDestino: 'TU PRÓXIMO DESTINO', soloIda: 'SOLO IDA', fechaOrc: 'FECHA DEL PRESUPUESTO', preparadoPara: 'PREPARADO PARA',
    vuelo: 'VUELO', directo: 'Vuelo directo', una: '1 conexión', varias: (n) => `${n} conexiones`, aerolinea: 'Aerolínea',
    salida: 'SALIDA', llegada: 'LLEGADA', valorTotal: 'VALOR TOTAL', validoHasta: 'Válido hasta', clase: 'Clase',
    formaPago: 'FORMA DE PAGO', formasPago: 'FORMAS DE PAGO', pagoPix: 'Pago por PIX',
    tarjetaHasta: (n) => `Tarjeta de crédito hasta ${n} cuotas`, hastaCuotas: (n) => `(hasta ${n} cuotas)`,
    observaciones: 'OBSERVACIONES', wsp: 'Escríbenos por WhatsApp', soporte1: 'Soporte', soporte2: 'especializado', buenViaje: '¡Buen viaje!',
    itinDe: (n) => `ITINERARIO DE ${n}`, itin: 'TU ITINERARIO DE VIAJE', itinCorto: 'TU ITINERARIO', saliendo: 'SALIENDO DE BOA VISTA', tuViaje: 'TU VIAJE',
    llegadaBV: 'LLEGADA A BOA VISTA', hospedaje: 'HOSPEDAJE EN BOA VISTA', noche: 'noche', noches: 'noches',
    delAl: (a, b) => `del ${a} al ${b}`, busBVM: 'ÓMNIBUS BOA VISTA → MANAUS', salidaA: (f, h) => `Salida ${f ? `${f} ` : ''}a las ${h}`,
    llegaManaus: (f, h) => `Llegada a Manaus ${f} a las ${h}`, llegaA: (f, h) => `Llegada ${f ? `${f} ` : ''}a las ${h}`,
    vueloMA: (d) => `VUELO MANAUS → ${d}`, busHasta: (c) => `ÓMNIBUS HASTA ${c}`, destinoFinal: 'EL DESTINO FINAL', horarioPorConfirmar: 'Horario por confirmar',
    valorPaquete: 'VALOR DEL PAQUETE', incluye: 'EL PAQUETE INCLUYE', paqueteCompleto: 'Paquete completo',
    inc1: 'Hospedaje en Boa Vista', inc2: 'Ómnibus Boa Vista → Manaus', inc3: (d) => `Pasaje aéreo Manaus${d ? ` → ${d}` : ''}`,
    oReales: (v, t) => `o R$ ${v}  (cambio R$ ${t})`, oRealesCorto: (v) => `o R$ ${v}`,
    hotel: 'HOTEL', servicio: 'SERVICIO', bus: 'ÓMNIBUS', checkIn: 'ENTRADA', checkOut: 'SALIDA', huespedes: (n) => `${n} ${n === 1 ? 'huésped' : 'huéspedes'}`,
    habitaciones: (n) => `${n} ${n === 1 ? 'habitación' : 'habitaciones'}`, detalle: 'DETALLE', total: 'TOTAL', pacoteFechado: 'Paquete cerrado',
    resumen: 'RESUMEN DEL PRESUPUESTO', incluyeLista: 'EL PRESUPUESTO INCLUYE',
  },
};

// Devuelve los textos del idioma (por defecto portugués) más helpers de fechas y pagos.
export function tx(idioma) {
  const id = idioma === 'es' ? 'es' : 'pt';
  return {
    ...TX[id], id, meses: MESES[id], semana: SEMANA[id],
    pago: (nombre) => PAGOS[id][nombre] || nombre,
    cabina: (c) => (id === 'es' ? (CABINAS_ES[String(c || '').toLowerCase()] || String(c || '').toLowerCase()) : String(c || '').toLowerCase()),
  };
}
